<template>
    <div class="app-badge">
        <img
            :src="require('../../../static/logo.svg')"
            alt="webphone-logo"
            width="24"
            height="24"
        />

        <span class="app-badge-text">Call parking wallboard</span>
    </div>
</template>

<script>
export default {
    name: "AppBadge"
}
</script>

<style scoped>

</style>